import { render, staticRenderFns } from "./feeNorm.vue?vue&type=template&id=5ef64542&"
import script from "./feeNorm.vue?vue&type=script&lang=js&"
export * from "./feeNorm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports